<template>
  <div
      style="width:100%"
  >
    <div style="display: flex;flex-direction: column">
      <div   style="flex-grow: 1">
        <s-remote-select

            options-repo="assets"
            v-model="assetId"
            style="font-size: 10px;width: 100%"
            @change="handleChange"></s-remote-select>
      </div>
      <div
          style="flex:1 0 30%"
          v-if="driversEnabled&&availableDrivers?.length">
        <q-btn v-if="availableDrivers.length>1"
               color="secondary"
               style="font-size: 10px;width: 100%;"
        >
          <div style="overflow: hidden;text-align: left;width: 100%">
            {{ oldDriver ? oldDriver.name : 'Driver?' }}
          </div>
          <q-popup-proxy>
            <q-banner>

              <q-btn-toggle
                  class="spread-cols"
                  v-model="selectedDriver"
                  toggle-color="primary"
                  :options="availableDrivers"
                  @input="oldDriver=null;$emit('update:contactId', selectedDriver);$emit('change', {vehicleId: assetId,contactId:selectedDriver})"/>
            </q-banner>
          </q-popup-proxy>
        </q-btn>
        <span v-else-if="oldDriver" style="font-size: 9px">{{ oldDriver.name }}</span>
        <!--      <span v-else-if="selectedDriver" >{{ selectedDriver.name }}</span >-->
      </div>
    </div>
  </div>


  <!--  </div >-->


</template>

<script>
import mdl from '~/mixins/mdl';
import SRemoteSelect from "./SRemoteSelect";
import {mapActions} from "vuex";

export default {
  name: 'VehiclePicker',
  components: {SRemoteSelect},
  props: {
    driversEnabled: {type: Boolean, default: true},
    nospaces: {type: Boolean, default: true},
    vehicleId: {
      type: [String,
        Number], default: null
    },
    contactId: {
      type: [String,
        Number], default: null
    },
    // value: {type: Object, default: () => null}
  },
  data() {
    return {
      assetId: null,
      oldDriver: null,
      selectedDriverName: null,
      selectedDriver: this.contactId,
      availableDrivers: null
    }
  },
  watch: {
    vehicleId: {
      handler(v, vo) {
        if (v == vo) return
        this.assetId = v + ""
        this.loadDrivers()
      },
      immediate: true
    }
  },
  computed: {},
  async created() {

    // await this.fetchAllOptions('drivers')
  },
  methods: {
    ...mapActions({
      fetch: "tags/fetch",
      fetchAllOptions: "tags/fetchAll",
    }),
    loadDrivers() {
      // _log_('handleChange.loadDrivers', this.assetId)
      // if (!this.driversEnabled) return
      this.oldDriver = null
      if (!this.assetId) {
        this.selectedDriver = null
        this.availableDrivers = []
        return
      }
      // _log_('laod drivers ')
      const av_vehicles = this.$store.getters['tags/getList']('assets'),
          the_vehicle = this.findInArray(av_vehicles, {id: this.assetId});

      if (the_vehicle && the_vehicle.drivers) {//&& the_vehicle.drivers.length > 1
        this.availableDrivers = the_vehicle.drivers.map((d) => {
          if (d) {
            d.label = d.name
            d.value = d.id
          }
          return d
        }).filter(v => !!v)
        if (the_vehicle.drivers?.length == 1) this.selectedDriver = the_vehicle.drivers[0].id
      } //else if( the_vehicle.drivers&& the_vehicle.drivers.length.length==1)
      else this.availableDrivers = null
      // _log_('fOUND.availableDriver', this.selectedDriver)
      // _log_('ffffw.this.availableDrivers', this.selectedDriver, the_vehicle, this.availableDrivers)
      if (this.contactId && (!this.availableDrivers || !this.findInArray(this.availableDrivers, {id: this.contactId}))) {
        // _log_('availableDriver check drivers ', this.contactId, this.$store.getters['tags/getList']('drivers'))
        this.oldDriver = this.findInArray(this.$store.getters['tags/getList']('drivers'), {id: this.contactId})
      } else if (this.selectedDriver) this.oldDriver = this.findInArray(this.$store.getters['tags/getList']('drivers'), {id: this.selectedDriver})

    },
    handleChange() {
      this.oldDriver = null
      // this.selectedDriver=null
      _log_('handleChange...0.', this.availableDrivers, this.selectedDriver)
      this.loadDrivers()
      if (!this.selectedDriver && this.availableDrivers?.length) this.selectedDriver = this.availableDrivers[0].id
      this.$emit('update:vehicleId', this.assetId);
      _log_('handleChange.', this.availableDrivers, this.selectedDriver)
      // if(!this.availableDrivers?.length)
      this.$emit('update:contactId', this.selectedDriver);
      this.$emit('change', {vehicleId: this.assetId, contactId: this.selectedDriver})
      // this.checked = this.value
      // this.$nextTick(()=> {
      //     this.checked ?
      //     this.$refs['mdl'].MaterialCheckbox.check() :
      //     this.$refs['mdl'].MaterialCheckbox.uncheck()
      // })
    },
  },
  // async mounted(){
  //    const data=await this.$store.dispatch('tags/fetch','assets')
  //    _log_('ffffw.',this.$store.state.tags.lists.assets)
  //  },

}
</script>
